import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as R from 'fp-ts/Record';
import { useRef } from 'react';
export var useFocusErrors = function useFocusErrors() {
  var questionRef = useRef(null);
  return {
    questionRef: questionRef,
    focusOnFirstError: function focusOnFirstError(errors) {
      if (!R.isEmpty(errors) && questionRef !== null && questionRef !== void 0 && questionRef.current) {
        var errorsList = R.keys(errors);
        pipe(Array.from(questionRef.current.children), A.findFirst(function (child) {
          return errorsList.includes(child.id);
        }), O.map(function (child) {
          return child.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'start'
          });
        }));
      }
    }
  };
};